import type { ComponentProps } from 'react';

import { CustomBlockquoteIcon } from '@nesso/ui/icons/custom-blockquote-icon';
import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';

export function TranscriptButton({ className, ...props }: ComponentProps<typeof Button>) {
    return (
        <Button
            variant="outline"
            size="icon"
            aria-label="Show transcript"
            className={cn(
                'shadow-[0_1px_2px_0_rgba(0,0,0,0.15)] data-[state=open]:bg-accent/50 data-[state=open]:text-accent-foreground',
                className,
            )}
            {...props}
        >
            <CustomBlockquoteIcon />
        </Button>
    );
}
